import request from '@/utils/request'

// 查询列表
export function scpSupplyList (query) {
  return request({
    url: '/scp/scpSupplyDefault/list',
    method: 'get',
    params: query
  })
}
// 供应列表-净值仓更新
export function listUpdateNetSubInventory (data) {
    return request({
      url: '/scp/scpSupplyDefault/listUpdateNetSubInventory',
      method: 'post',
      data: data
    })
  }
